<template>
  <footer class="footer" style="min-height: 60vh">
    <img src="/images/logo_bleu.svg" class="footer__logo" v-reveal />

    <div class="footer__menu" v-if="!isFaq">
      <template v-for="(item, key) in secondaryMenuItems" :key="key">
        <RouterLink
          v-if="isInternalMenuItem(item)"
          v-reveal
          class="footer__menu-item"
          :to="item.link"
        >
          {{ item.label }}
        </RouterLink>

        <a
          v-else-if="item.link"
          v-reveal
          class="footer__menu-item"
          target="_blank"
          rel="noopener"
          :href="item.link"
        >
          {{ item.label }}
        </a>
      </template>
    </div>
    <div class="footer__row">
      <div class="footer__links">
        <a v-reveal class="footer__link" :href="`tel:${contact.phone}`">{{ contact.phone }}</a>
        <a v-reveal class="footer__link" :href="`mailto:${contact.email}`">{{ contact.email }}</a>
        <a v-reveal class="footer__link" :href="contact.links.booking" target="_blank">{{
          $t('reservation')
        }}</a>
        <a v-reveal class="footer__link" :href="contact.links.gift_card" target="_blank">{{
          $t('giftCard')
        }}</a>
        <a v-reveal class="footer__link" :href="contact.privacy_policy.original" target="_blank">{{
          $t('privacyPolicy')
        }}</a>

        <div class="footer__address" v-reveal>
          <div>{{ contact.address.name }}</div>
          <a class="footer__link" :href="contact.address.link" target="_blank">{{
            $t('itineraire')
          }}</a>
        </div>
      </div>
      <div class="footer__row-buttons">
        <div class="footer__lang" v-reveal>
          <button @click="$i18n.locale = 'fr'">FR</button> /
          <button @click="$i18n.locale = 'en'">EN</button> /
          <GoogleTranslate style="font-size: 14px; margin-top: -0.35rem" />
        </div>

        <div class="footer__row-buttons">
          <div class="footer__row-flex" v-reveal>
            <a :href="contact.socials.facebook" target="_blank" class="button-white button-footer"
              >facebook</a
            >
            <a :href="contact.socials.instagram" target="_blank" class="button-white button-footer"
              >instagram</a
            >
          </div>
          <a
            v-reveal
            :href="contact.links.maestro"
            target="_blank"
            class="button-white button-footer"
            >groupe maestro</a
          >
        </div>
      </div>
    </div>

    <div class="footer__valet" v-reveal>
      {{ contact.site_name }}
    </div>

    <div class="footer__horaire" v-reveal>
      <h3 class="footer__horaire-title">{{ footer.opening_hours.title }}</h3>
      <div class="footer__horaire-item">{{ footer.opening_hours.description }}</div>
    </div>

    <div class="footer__logos">
      <a
        href="https://fr.tripadvisor.ca/Restaurant_Review-g155033-d12579852-Reviews-Restaurant_Ophelia-Quebec_City_Quebec.html"
        target="_blank"
      >
        <img
          class="footer__tripadvisor"
          src="/images/tchotel_2022_LL.png"
          alt="TripAdvisor"
          width="151"
          height="100"
          v-reveal
        />
      </a>
      <a href="https://quebecaumenu.com/" target="_blank">
        <img
          class="footer__tripadvisor"
          src="/images/AlimentsDuQuebec_Logo_Noir.png"
          alt="TripAdvisor"
          width="151"
          height="100"
          v-reveal="{ delay: 300 }"
        />
      </a>
    </div>

    <div class="footer__watermark">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="66px"
        height="62px"
        viewBox="0 0 66 62"
        version="1.1"
      >
        <defs />
        <g
          id="Welcome"
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
          opacity="0.54127038"
        >
          <g
            id="ophelia-maquette-V2-1440px"
            transform="translate(-688.000000, -4692.000000)"
            fill="#0D1B2C"
          >
            <g id="Menu-+-Visionneuse" transform="translate(219.000000, 1909.000000)">
              <g id="Footer" transform="translate(1.000000, 2379.000000)">
                <g id="Contact" transform="translate(0.000000, 97.000000)">
                  <g id="Icone" transform="translate(468.000000, 307.000000)">
                    <polygon
                      id="Fill-1"
                      points="54.729675 22.1161019 54.729675 40.0475547 56.3826214 38.9666491 56.3826214 21.0334415"
                    />
                    <polygon
                      id="Fill-2"
                      points="46.6263482 29.7612283 45.4807768 31.3211717 64.4870089 31.3211717 65.6325804 29.7612283"
                    />
                    <polygon
                      id="Fill-3"
                      points="43.1355375 33.055534 43.1355375 50.9869868 44.7884839 49.9060811 44.7884839 31.9728736"
                    />
                    <polygon
                      id="Fill-4"
                      points="35.0322107 40.7006604 33.8866393 42.2606038 52.8911036 42.2606038 54.036675 40.7006604"
                    />
                    <polygon
                      id="Fill-5"
                      points="31.5414 43.994966 31.5414 61.9264189 33.1943464 60.8455132 33.1943464 42.9140604"
                    />
                    <polygon
                      id="Fill-6"
                      points="23.4396643 51.6400925 22.2940929 53.2000358 41.2985571 53.2000358 42.4441286 51.6400925"
                    />
                    <polygon
                      id="Fill-7"
                      points="34.0902964 0.000350943395 32.43735 1.0812566 32.43735 19.0127094 34.0902964 17.9318038"
                    />
                    <polygon
                      id="Fill-8"
                      points="24.3338464 8.72726038 23.188275 10.2854491 42.1927393 10.2854491 43.3383107 8.72726038"
                    />
                    <polygon
                      id="Fill-9"
                      points="20.8430357 12.0199868 20.8430357 29.9514396 22.4959821 28.8722887 22.4959821 10.9390811"
                    />
                    <polygon
                      id="Fill-10"
                      points="12.7397089 19.6666925 11.5941375 21.2248811 30.5986018 21.2248811 31.7459411 19.6666925"
                    />
                    <polygon
                      id="Fill-11"
                      points="9.24889821 22.9594189 9.24889821 40.8908717 10.9018446 39.8117208 10.9018446 21.8785132"
                    />
                    <polygon
                      id="Fill-12"
                      points="1.14557143 30.6061245 0 32.1643132 19.0062321 32.1643132 20.1518036 30.6061245"
                    />
                    <polygon
                      id="Fill-13"
                      points="43.5826286 11.5983283 43.5826286 29.5297811 45.235575 28.4488755 45.235575 10.5174226"
                    />
                    <polygon
                      id="Fill-14"
                      points="35.4808929 19.2434547 34.3335536 20.8033981 53.3397857 20.8033981 54.4853571 19.2434547"
                    />
                    <polygon
                      id="Fill-15"
                      points="31.9900821 22.5377604 31.9900821 40.4692132 33.6412607 39.3883075 33.6412607 21.4568547"
                    />
                    <polygon
                      id="Fill-16"
                      points="23.8867554 30.1828868 22.7411839 31.7428302 41.7456482 31.7428302 42.8912196 30.1828868"
                    />
                    <polygon
                      id="Fill-17"
                      points="20.3959446 33.4771925 20.3959446 51.4086453 22.0488911 50.3294943 22.0488911 32.3962868"
                    />
                    <polygon
                      id="Fill-18"
                      points="12.2926179 41.1238981 11.1470464 42.6820868 30.1515107 42.6820868 31.29885 41.1238981"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </div>

    <BeetCredits />
  </footer>
</template>

<script>
import BeetCredits from '@/components/small/BeetCredits.vue'

import GoogleTranslate from './GoogleTranslate.vue'

export default {
  name: 'Footer',
  components: { BeetCredits, GoogleTranslate },
  methods: {
    isInternalMenuItem(item) {
      return item.flexLayout === 'internal-link-repeatable'
    },
  },
  computed: {
    footer() {
      return this.$beet?.options?.footer || {}
    },

    contact() {
      return this.$beet?.options?.contact || null
    },

    secondaryMenuItems() {
      return this.$beet?.options?.menus?.secondary || []
    },

    isFaq() {
      const path = this.$route.path?.replace(/\/$/, '')
      const hash = this.$route.hash || ''

      return (
        path === '/faq' || path?.endsWith('/faq') || hash === '#faq' || hash.startsWith('#faq-')
      )
    },
  },
}
</script>
